<template>
  <div>
    <small class="font-italic"
      >La participation de: {{ user.name }} {{ user.last_name }}
    </small>

    <div>
      <div class="mr-5 text-success d-lg-inline-block">
        Parce que ({{ totalComments.positive }})
      </div>
      <div class="mr-5 text-danger d-lg-inline-block">
        Par contre ({{ totalComments.negative }})
      </div>
      <div class="mr-5 text-purple d-lg-inline-block mb-3 mb-lg-0">
        Donc ({{ totalComments.neutral }})
      </div>
      <span class="mr-5">
        <b-icon class="mr-1" icon="chat-fill" variant="secondary"></b-icon>
        <span>{{
          totalComments.positive +
            totalComments.negative +
            totalComments.neutral
        }}</span>
      </span>
      <span class="mr-5">
        <b-icon class="mr-1" icon="eye-slash" variant="secondary"></b-icon>
        <span>{{ mask }}</span>
      </span>
      <span class="mr-5">
        <b-icon class="mr-1" icon="envelope-fill" variant="secondary"></b-icon>
        <span>{{ responses }}</span>
      </span>
    </div>
    <section>
      <div v-for="comment in comments" :key="comment.id">
        <p>
          <span class="d-block">{{ user.name }} {{ user.last_name }}</span>
          <small class="text-muted">{{
            comment.created_at | formatDateTime
          }}</small>
        </p>
        <p>
          <span class="text-success mr-10" v-if="comment.type == 1">
            Parce que
          </span>
          <span class="text-danger mr-1" v-if="comment.type == 2">
            Par contre
          </span>
          <span class="text-primary mr-1" v-if="comment.type == 3">
            Donc
          </span>
          {{ comment.comment }}
        </p>
        <div v-if="comment.messages.length != 0">
          <b-row>
            <b-col cols="1" sm="1" md="1" lg="1" class="text-right">
              <b-icon class="mr-1" icon="envelope" variant="secondary"></b-icon>
            </b-col>
            <b-col>
              <div v-for="message in comment.messages" :key="message.id">
                <span class="d-block">
                  {{ message.user.name }} {{ message.user.last_name }}
                </span>
                <span class="text-muted">{{ message.created_date }}</span>
                <p>
                  {{ message.message }}
                </p>
              </div>
            </b-col>
          </b-row>
        </div>
        <hr />
      </div>
    </section>
  </div>
</template>

<script>
/**
 * @file       Students email content body component.
 * @author     Appwapp <info@appwapp.com>
 * @copyright  © Centre collégial de développement de matériel didactique, Collège de Maisonneuve, 2021
 * @license    https://www.ccdmd.qc.ca
 * @version    1.0
 */

import { adminStudentMixin } from "@/modules/admin/components/students/mixins";
import store from "@/store";

/**
 * Export the component.
 * 
 * @type  {Object}
 */
export default {
  name: "studentContentBody",
  mixins: [adminStudentMixin],
  props: {
    deliberation: Number,
    groupId: Number
  },

  /**
   * Data used in the component.
   *
   * @return  {Object}
   */
  data() {
    return {
      comments: Array
    };
  },

  /**
   * Methods.
   * 
   * @type  {Object}
   */
  methods: {
    /**
     * Get comments.
     */
    getComments() {
      store.commit("comments/setCommentsFilters", {
        reset: true,
        fields: {
          deliberation: this.deliberation,
          user: this.user.id,
          resourcesPerPage: 500
        }
      });
      store.dispatch("comments/getComments").then(response => {
        this.comments = response.data.data;
      });
    }
  },
  created() {
    this.getComments();
  },

  /**
   * Computed properties.
   * 
   * @type  {Object}
   */
  computed: {
    totalComments: function() {
      var comments = this.totalGrades
        .find(tg => tg.group == this.groupId)
        .deliberations.find(u => u.deliberation === this.deliberation);
      comments = comments.total_comments_types;
      return comments;
    },
    mask: function() {
      var mask = this.totalGrades
        .find(tg => tg.group == this.groupId)
        .deliberations.find(u => u.deliberation === this.deliberation);
      mask = mask.masked_comments;
      return mask;
    },
    responses: function() {
      var responses = this.totalGrades
        .find(tg => tg.group == this.groupId)
        .deliberations.find(u => u.deliberation === this.deliberation);
      responses = responses.sufficiency.responses;
      return responses;
    }
  }
};
</script>

<style lang="scss" scoped></style>
